<template>
  <div class="page">

    <Plot :data="plotDataTrends" :layout="plotLayoutTrends" :div-id="`plot-trend`"/>   

    <div class="remediations">
      <b>Available remediations</b>
      <div class="top">
        <!--<div>
          Remediations {{remediation.remediations.length}} of {{remediation.remediations.length}}
        </div>-->
        <div>
          <button id="refreshRemediationBtn" @click="refreshRemediation">Refresh</button>
        </div>
      </div>
      <RemediationItem v-for="remediation in remediation.remediations" :key="remediation.id" :remediation="remediation"/>
    </div>

    <div class="remediationLog">
      <b>Remediation Log</b>
      <div class="top">
        <div>
          <button id="refreshRemediationLogBtn" @click="refreshRemediationLog">Refresh</button>
        </div>
      </div>
      <RemediationItem v-for="remediation in remediationLog" :key="remediation.id" :remediation="remediation"/>
    </div>
    <div class="debugDiv">
      <pre class="debug" v-show="debugMode">{{remediation}}</pre>
    </div>

  </div>


</template>

<style>
</style>

<script>
import Plot from '@/components/Plot.vue'
import { mapState } from 'vuex'
import RemediationItem from '@/components/RemediationItem.vue'

export default {
  name: 'remediation',
  components: {
    Plot,
    RemediationItem
  },
  computed: {
    plotDataTrends: function () {
      if (!this.remediation.trend_12m) return []
      /* Collect date labels */
      // var dates = []
      // for (var date in this.exposure.trend) {
      //   dates.push(date)
      // }
      // dates.sort()
      // console.log('dates', dates)
      /* Collect data */
      var x = []
      var risk = []
      var risk_residual = []
      var risk_remediated = []
      for (let date in this.remediation.trend_12m) {
        x.push(date)
      }
      x.sort()
      for (let i in x) {
        let date = x[i]
        risk.push(this.remediation.trend_12m[date]['risk'])
        risk_residual.push(this.remediation.trend_12m[date]['risk_residual'])
        risk_remediated.push(this.remediation.trend_12m[date]['risk_remediated'])
      }
      var trace_risk = {x: x, y: risk, mode: 'lines+markers', type: 'scatter', line: {shape: 'spline'}, name: 'Risk'}
      var trace_risk_residual = {x: x, y: risk_residual, mode: 'lines+markers', type: 'scatter', line: {shape: 'spline'}, name: 'Residual'}
      var trace_risk_remediated = {x: x, y: risk_remediated, mode: 'lines+markers', type: 'scatter', line: {shape: 'spline'}, name: 'Remediated'}
      var data = [trace_risk, trace_risk_residual, trace_risk_remediated]
      return data
    },
    ...mapState([
      'debugMode',
      'account',
      'profile',
      'remediation',
      'remediationLog'
    ])
  },
  methods: {
    refreshRemediation () {
      if (!this.profile.id) return
      this.$store.dispatch('loadRemediation')
    },
    refreshRemediationLog () {
      if (!this.profile.id) return
      this.$store.dispatch('loadRemediationLog')
    }
  },
  watch: {
    profile () {
      this.refreshRemediation()
      this.refreshRemediationLog()
    }
  },
  mounted () {
    this.refreshRemediation()
    this.refreshRemediationLog()
  },
  data () {
    return {
      plotLayoutTrends: {
        title: 'Trend',
        width: '100%',
        plot_bgcolor: '#eeeeee',
        paper_bgcolor: '#eeeeee',
        yaxis: {
          // type: 'log',
          autorange: true,
          showgrid: false,
          showticklabels: false
        }
      },
    }
  }
}
</script>
